import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { ApiEndpoints } from "../_helpers/api-endpoints";
import { AccessDevice } from "../_models/access-device.model";

@Injectable({
  providedIn: "root",
})
export class AccessDeviceService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<AccessDevice[]> {
    return this.http.get<AccessDevice[]>(ApiEndpoints.accessDevice.getAll());
  }

  get(id: string): Observable<AccessDevice> {
    return this.http.get<AccessDevice>(ApiEndpoints.accessDevice.get(id));
  }

  getByIdentifier(identifier: string): Observable<AccessDevice> {
    return this.http.get<AccessDevice>(ApiEndpoints.accessDevice.getByIdentifier(identifier));
  }

  post(newDevice: AccessDevice): Observable<AccessDevice> {
    return this.http.post<AccessDevice>(ApiEndpoints.accessDevice.post(), newDevice).pipe(
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  put(updatedAccessDevice: any): Observable<AccessDevice> {
    return this.http
      .put<AccessDevice>(ApiEndpoints.accessDevice.put(), updatedAccessDevice)
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(ApiEndpoints.accessDevice.delete(id)).pipe(
      catchError((error) => {
        return throwError(error);
      })
    );
  }
}
